module.exports = __webpack_public_path__ + "img/mobile-57.7176b65d.png";